<app-header></app-header>
<app-menu-bar></app-menu-bar>
<router-outlet *ngIf="backendIsAlive"></router-outlet>
<div class="server-not-available" *ngIf="!backendIsAlive">erreur serveur</div>


